/* eslint-disable @typescript-eslint/no-var-requires */
export const { default: VICon } = require('./product.png');
export const { default: PVIcon } = require('./cc.png');
export const { default: UVIcon } = require('./catalog.png');
export const { default: VVICon } = require('./dollar.png');
export const { default: VVCon } = require('./peop1.png');
export const { default: VVeCon } = require('./peop2.png');
export const { default: VerCon } = require('./erp.png');


